<template>

    <transition name="modal-fade">

        <div
            class="modal-overlay"
            v-if="chequeModal"
        >

            <div class="cheque-modal">

                <!-- CLOSE -->
                <button
                    class="close-btn"
                    @click="closeModal"
                >
                    ✕
                </button>

                <!-- HEADER -->
                <div class="modal-header">

                    <div class="header-text">

                        <h2>
                            הוספת שיק חדש
                        </h2>

                        <p>
                            נהל את פרטי השיק בצורה פשוטה
                        </p>

                    </div>

                  

                </div>

                <!-- ERROR -->
                <div
                    class="error-box"
                    v-if="errorDealer"
                >
                    {{ errorAddingDealer }}
                </div>

                <!-- CONTENT -->
                <div class="modal-content">

                    <!-- FORM -->
                    <div class="modal-form">

                        <!-- DEALER -->
                        <div class="glass-input">

                            <label>
                                שם הלקוח
                            </label>

                            <input
                                type="text"
                                v-model="localCheque.dealerName"
                                list="exampleList"
                                placeholder="בחר לקוח..."
                            >

                            <datalist id="exampleList">

                                <option
                                    :value="person.Data.selectDealerName"
                                    v-for="person in Dealers"
                                    :key="person.id"
                                ></option>

                            </datalist>

                        </div>
                        <div class="glass-input">
                        <label>בנק</label>
                        <select v-model="localCheque.bank" class="bank-select">
                            <option value="">בחר בנק (לא חובה לשיקים ישנים)</option>
                            <option value="לאומי">בנק לאומי</option>
                            <option value="דיסקונט">בנק דיסקונט</option>
                        </select>
                        </div>
                        <!-- AMOUNT -->
                        <div class="glass-input">

                            <label>
                                סכום השיק
                            </label>

                            <input
                                type="number"
                                v-model.number="localCheque.amount"
                                placeholder="₪ 0.00"
                            >

                        </div>

                        <!-- DATE -->
                        <div class="glass-input">

                            <label>
                                תאריך פירעון
                            </label>

                            <input
                                type="date"
                                v-model="localCheque.formattedDate"
                            >

                        </div>

                        <!-- NOTES -->
                        <div class="glass-input">

                            <label>
                                הערות
                            </label>

                            <textarea
                                rows="3"
                                v-model="localCheque.notes"
                                placeholder="הוסף הערות..."
                            ></textarea>

                        </div>

                    </div>

                    <!-- PREVIEW -->
                    <div class="preview-card">

                        <span class="preview-label">
                            תצוגה מקדימה
                        </span>

                        <h1>
                            ₪{{ localCheque.amount || '0' }}
                        </h1>

                        <p>
                            {{ localCheque.dealerName || 'שם לקוח' }}
                        </p>

                        <span class="preview-date">
                            {{
                                localCheque.formattedDate
                                || '--/--/----'
                            }}
                        </span>

                    </div>

                </div>

                <!-- ACTIONS -->
                <div class="modal-actions">

                    <button
                        class="save-btn"
                        @click="addCheque"
                    >
                        שמור שיק
                    </button>

                    <button
                        class="cancel-btn"
                        @click="closeModal"
                    >
                        ביטול
                    </button>

                </div>

            </div>

        </div>

    </transition>

</template>

<script>

import { db } from '../firebase';
import firebase from "firebase/app";
import "firebase/messaging";
import moment from 'moment';


export default {

    props: {

        chequeModal: {
            type: Boolean,
            default: false
        },

        Dealers: {
            type: Array,
            default: () => []
        }

    },

    data() {

        return {

            errorDealer: false,

            errorAddingDealer: '',

            localCheque: {
                dealerName: '',
                amount: null,
                formattedDate: '',
                notes: '',
                bank: 'לאומי'
            }

        }

    },

    methods: {

        closeModal() {

            this.resetForm()

            this.$emit('close')

        },

        resetForm() {

           this.localCheque = {
            dealerName: '',
            amount: null,
            formattedDate: '',
            notes: '',
            bank: 'לאומי'
        }

            this.errorDealer = false
            this.errorAddingDealer = ''

        },

       async addCheque() {

    let vm = this

    vm.errorDealer = false
    vm.errorAddingDealer = ''

    if (
        vm.localCheque.dealerName.length <= 0
        || !vm.localCheque.amount
        || vm.localCheque.formattedDate.length <= 0
    ) {

        vm.errorDealer = true

        vm.errorAddingDealer =
            "נא למלא את כל השדות"

        return

    }

    const dateObject = moment(
        vm.localCheque.formattedDate,
        "YYYY-MM-DD",
        true
    )

    const timestamp =
        firebase.firestore.Timestamp.fromDate(
            dateObject.toDate()
        )

    let cheque = {

        dealerName:
            vm.localCheque.dealerName,
            
            bank: vm.localCheque.bank || '',
        amount:
            vm.localCheque.amount,

        date:
            timestamp,

        formattedDate:
            vm.localCheque.formattedDate,

        notes:
            vm.localCheque.notes || '',

        createdDate:
            moment().format('LLLL'),

        checked:
            false

    }

    // 🔥 ابعت البيانات للـ App.vue
    this.$emit(
        'save',
        cheque
    )

    this.closeModal()

}

    }

}

</script>
<style scoped>

/* OVERLAY */

.modal-overlay {
    position: fixed;
    inset: 0;
    z-index: 99999;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    background:
        rgba(15, 23, 42, 0.18);
    backdrop-filter: blur(14px);
    -webkit-backdrop-filter:
        blur(14px);
}

/* MODAL */

.cheque-modal {
    width: 100%;
    max-width: 920px;
    border-radius: 38px;
    padding: 30px;
    background:
        rgba(255,255,255,0.72);
    backdrop-filter: blur(30px);
    -webkit-backdrop-filter:
        blur(30px);
    box-shadow:
        0 25px 80px rgba(0,0,0,0.10);
    position: relative;
    overflow: hidden;

}

/* CLOSE */

.close-btn {
    position: absolute;
    top: 22px;
    left: 22px;
    width: 54px;
    height: 54px;
    border: none;
    border-radius: 22px;
    background:
        rgba(255,255,255,0.55);
    backdrop-filter: blur(20px);
    font-size: 20px;
    color: #0f172a;
    cursor: pointer;
    transition:
        transform .2s ease,
        background .2s ease;

}

.close-btn:hover {
    background:
        rgba(255,255,255,0.75);
}

.close-btn:active {
    transform: scale(.95);
}

/* HEADER */

.modal-header {
    background-color: transparent;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 30px;
}

.header-text h2 {
    margin: 0;
    font-size: 36px;
    font-weight: 800;
    color: #0f172a;
}

.header-text p {
    margin-top: 8px;
    font-size: 15px;
    color: #6b7280
}

.header-icon {
    width: 78px;
    height: 78px;
    border-radius: 28px;

    background:
        linear-gradient(
            135deg,
            #7ce7c0,
            #4fd7aa
        );
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 34px;
    box-shadow:
        0 12px 30px rgba(124,231,192,0.35);

}

/* ERROR */

.error-box {
    margin-bottom: 22px;
    padding: 16px 18px;
    border-radius: 22px;
    background:
        rgba(255, 79, 79, 0.12);
    color: #dc2626;
    font-size: 15px;
    font-weight: 600;

}

/* CONTENT */

.modal-content {
    display: grid;
    grid-template-columns:
        1.2fr
        .8fr;

    gap: 24px;

}

/* FORM */

.modal-form {
    display: flex;
    flex-direction: column;
    gap: 18px;

}

/* GLASS INPUT */

.glass-input {
    padding: 18px;
    border-radius: 28px;
    background:
        rgba(255,255,255,0.45);

    backdrop-filter: blur(18px);
    border:
        1px solid rgba(255,255,255,0.35);

}

.glass-input label {

    display: block;

    margin-bottom: 12px;

    font-size: 14px;
    font-weight: 700;

    color: #374151;

}

/* INPUTS */

.glass-input input,
.glass-input textarea {

    width: 100%;

    border: none;

    outline: none;

    background:
        rgba(255,255,255,0.7);

    border-radius: 20px;

    padding: 0 18px;

    font-size: 16px;

    color: #0f172a;

    transition:
        border .2s ease,
        background .2s ease;

}

.glass-input input {

    height: 58px;

}

.glass-input textarea {

    min-height: 110px;

    padding-top: 16px;

    resize: none;

}

/* FOCUS */

.glass-input input:focus,
.glass-input textarea:focus {

    background:
        rgba(255,255,255,0.95);

}

/* PLACEHOLDER */

.glass-input input::placeholder,
.glass-input textarea::placeholder {

    color: #9ca3af;

}

/* PREVIEW */

.preview-card {

    border-radius: 34px;

    padding: 28px;

    background:
        linear-gradient(
            135deg,
            #ecfff7,
            #f7fffc
        );

    border:
        1px solid rgba(124,231,192,0.35);

    display: flex;

    flex-direction: column;

    justify-content: center;

    min-height: 100%;

    position: relative;

    overflow: hidden;

}

.preview-card::before {

    content: '';

    position: absolute;

    width: 280px;
    height: 280px;

    border-radius: 50%;

    background:
        rgba(124,231,192,0.12);

    top: -120px;
    left: -120px;

}

/* PREVIEW CONTENT */

.preview-label {

    position: relative;

    font-size: 14px;
    font-weight: 700;

    color: #0f766e;

    margin-bottom: 20px;

}

.preview-card h1 {

    position: relative;

    margin: 0;

    font-size: 58px;

    line-height: 1;

    color: #0f172a;

}

.preview-card p {

    position: relative;

    margin-top: 20px;

    font-size: 20px;
    font-weight: 700;

    color: #1f2937;

}

.preview-date {

    position: relative;

    margin-top: 10px;

    color: #6b7280;

    font-size: 15px;

}

/* ACTIONS */

.modal-actions {

    margin-top: 30px;

    display: flex;

    gap: 16px;

}

/* SAVE */

.save-btn {

    flex: 1;

    height: 64px;

    border: none;

    border-radius: 24px;

    background:
        linear-gradient(
            135deg,
            #7ce7c0,
            #39d8a2
        );

    color: #014342;

    font-size: 18px;
    font-weight: 800;

    cursor: pointer;

    box-shadow:
        0 14px 30px rgba(124,231,192,0.35);

    transition:
        transform .2s ease,
        box-shadow .2s ease;

}

.save-btn:hover {

    transform: translateY(-2px);

}

.save-btn:active {

    transform: scale(.98);

}

/* CANCEL */

.cancel-btn {

    width: 180px;

    border: none;

    border-radius: 24px;

    background:
        rgba(255,255,255,0.6);

    backdrop-filter: blur(18px);

    font-size: 16px;
    font-weight: 700;

    color: #374151;

    cursor: pointer;

}

/* ANIMATION */

.modal-fade-enter-active,
.modal-fade-leave-active {

    transition: all .25s ease;

}

.modal-fade-enter,
.modal-fade-leave-to {

    opacity: 0;

    transform: scale(.96);

}

/* MOBILE */

@media (max-width: 900px) {

    .modal-content {

        grid-template-columns: 1fr;

    }

    .preview-card {

        min-height: 220px;

    }

}

@media (max-width: 768px) {

    .modal-overlay {

        padding: 14px;

        align-items: flex-end;

    }

    .cheque-modal {

        border-radius:
            34px
            34px
            0
            0;

        padding: 24px;

        max-height: 92vh;

        overflow-y: auto;

    }

    .header-text h2 {

        font-size: 28px;

    }

    .preview-card h1 {

        font-size: 44px;

    }

    .modal-actions {

        flex-direction: column;

    }

    .cancel-btn {

        width: 100%;
        height: 58px;

    }

    .save-btn {

        height: 58px;

    }

}

</style>


// WEBPACK FOOTER //
// src/components/AddChequeModal.vue